

import { Fragment, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogFooter,
  Spinner,
} from "@material-tailwind/react";
import { useShared } from "../../hooks/useShared";
export default function CloseNotfication({v}) {

  const { http,showRentalCloseDialog, setShowRentalCloseDialog, model, setModel } = useShared();
  const [loading, setLoading] = useState(false)


  const closeDialog = (value) => {
    setShowRentalCloseDialog(false)
      setModel(null)

  };

    const closeRental = () => {
        console.log("closeRental ", model)
        if (model?.rental_items.expiry) {
            setLoading(true)
            http.update(`api/items/${model?.rental_items.id}`, { status: 4 }).then(res => {
                console.log(res)
                if (res.data.success)
                    closeDialog()
                setLoading(false)
                v.refersh()
            }, err => {
              console.log(err);
              setLoading(false)
            })

        }else {
          closeDialog()
        }
    }

  return (
    <Fragment>
    
    <Dialog open={showRentalCloseDialog}  className="min-w-[90%] md:!min-w-[10%] border-main-color absolute top-0" size="sm"
     animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
    >
      <DialogHeader className="bg-main-color p-2 text-blue-gray-100  text-base">Hide Rental Notification</DialogHeader>
    
      <DialogFooter className=" p-2">
        <Button
          variant="text"
          color="red"
          onClick={()=>setShowRentalCloseDialog(false)}
          className="mr-1"
        >
          <span>بستن</span>
        </Button>
        <Button className="bg-main-color" onClick={closeRental}>
        {loading ? <Spinner color="teal" className="h-4 w-4" /> : <span> ارسال</span>}
        </Button>
      </DialogFooter>
    </Dialog>
  </Fragment>
  )
}

